module.exports = __webpack_public_path__ + "images/ExternalPromo/mike-square-2.jpg?7a0bb";